import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget, isPending } from "../../store/actions/todoActions";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { toast } from "react-toastify";
import { ReactComponent as DefenderIcon } from "../../assets/icon/DSADD 1.svg";
import { ReactComponent as MoneyIcon } from "../../assets/icon/money.svg";
import ConditionalRender from "../../components/Common/ConditionalRender";
import ModalBox from "../../components/Common/ModalBox";
import { formatRupiah, useHandleClickLoading } from "../../components/Common/utils";
import PaymentMethodComponent from "../product/PaymentMethodComponent";
import ModalOrderConfirm from "../product/ModalOrderConfirm";
import { ReactComponent as MemberStandarIcon } from "../../assets/membership/member.svg";
import { ReactComponent as MemberSilverIcon } from "../../assets/membership/silver.svg";
import { ReactComponent as MembergoldIcon } from "../../assets/membership/gold.svg";
import { ReactComponent as MemberProIcon } from "../../assets/membership/pro.svg";

function MembershipPages() {
    const isLogin = localStorage.getItem("isLogin");
    const isProfile = localStorage.getItem("isProfile");
    const profileData = JSON.parse(isProfile);
    const [listMemberData, setListMemberData] = useState([]);
    const [paymentData, setPaymentData] = useState([]);

    const [listMemberLoading, setListMemberLoading] = useState(true);
    const [paymentLoading, setPaymentLoading] = useState(true);

    const [selectedrekPayment, setselectedrekPayment] = useState([]);
    const [selectedPaymentItems, setSelectedPaymentItems] = useState([]);
    const [membership, setMembership] = useState({ nama: "", harga: 0 });
    const [orderConfirm, setOrderConfirm] = useState([]);
    const [invoice, setInvoice] = useState(0);

    const [hargaFix, setHargaFix] = useState({ harga: 0, logo: "" });
    const [isModalOrderConfirm, setIsModalOrderConfirm] = useState(false);
    const [isModalSuccessTransaction, setIsModalSuccessTransaction] = useState(false);

    const dispatch = useDispatch();
    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {
        if (isLogin) {
            const parseLogin = JSON.parse(isLogin);
            fetchListMembership(parseLogin?.apiKey, parseLogin?.token);
        }
        fetchDataPayment();
        dispatch(isIdTarget(undefined));
    }, [dispatch]);

    const fetchListMembership = async (api_key, token) => {
        setListMemberLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("api_key", api_key);

            const response = await ApiService({
                baseurl: "user/hargaMembership",
                method: "POST",
                XGORDON: "HARGAMEMBERSHIP",
                apiKey: api_key,
                token: token,
                body: params,
            });
            setListMemberLoading(false);
            if (response?.statusCode === 200) {
                setListMemberData(response.result.data);
            } else {
                setListMemberData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchDataPayment = async () => {
        setPaymentLoading(true);
        try {
            const response = await ApiService({
                baseurl: "user/pembayaran",
                method: "POST",
                XGORDON: "PEMBAYARAN",
            });
            setPaymentLoading(false);
            if (response?.statusCode === 200) {
                setPaymentData(response.result.data);
            } else {
                setPaymentData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getOrderConfirm = async () => {
        dispatch(isPending(true));
        const transformedDatalayanan = { id: membership?.nama };
        const transformedDataPayment = { metode: selectedPaymentItems.id };
        const transformedDataKontak = { kontak: profileData?.ponsel };
        const transformedDataphonePayment =
            selectedrekPayment?.length === 0
                ? null
                : selectedrekPayment[0].nama === "Saldo"
                    ? { pintrx: selectedrekPayment[0].value }
                    : { rek: selectedrekPayment[0].value };
        // Menggabungkan semua objek menjadi satu objek tunggal
        const combinedData = {
            ...transformedDatalayanan,
            ...transformedDataPayment,
            ...transformedDataKontak,
            ...transformedDataphonePayment,
        };
        const parsedObject = JSON.parse(isLogin);
        try {
            const params = new URLSearchParams();
            for (const key in combinedData) {
                params.append(key, combinedData[key]);
            }
            params.append("api_key", parsedObject?.apiKey);
            params.append("layanan", "upgrade");

            const response = await ApiService({
                baseurl: "user/orderConfirmMembership",
                method: "POST",
                XGORDON: "ORDERCONFIRMMEMBERSHIP",
                body: params,
                apiKey: parsedObject?.apiKey,
                token: parsedObject?.token
            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                setOrderConfirm(response.result.data);
                toggleModalOrderConfirm();
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setOrderConfirm([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const setOrderFix = async (tokenSHA) => {
        dispatch(isPending(true));
        const transformedDatalayanan = { id: membership?.nama };
        const transformedDataPayment = { metode: selectedPaymentItems.id };
        const transformedDataKontak = { kontak: profileData?.ponsel };
        const transformedDataphonePayment =
            selectedrekPayment?.length === 0
                ? null
                : selectedrekPayment[0].nama === "Saldo"
                    ? { pintrx: selectedrekPayment[0].value }
                    : { rek: selectedrekPayment[0].value };
        // Menggabungkan semua objek menjadi satu objek tunggal
        const combinedData = {
            ...transformedDatalayanan,
            ...transformedDataPayment,
            ...transformedDataKontak,
            ...transformedDataphonePayment,
        };
        const parsedObject = JSON.parse(isLogin);
        try {
            const params = new URLSearchParams();
            for (const key in combinedData) {
                params.append(key, combinedData[key]);
            }
            params.append("api_key", parsedObject?.apiKey);
            params.append("layanan", "upgrade");

            const response = await ApiService({
                baseurl: "user/order",
                method: "POST",
                customHeaders: { "x-gorgon": tokenSHA },
                body: params,
                apiKey: parsedObject?.apiKey,
                token: parsedObject?.token
            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                toggleModalOrderConfirm();
                toggleModalSuccessTransaction();
                setInvoice(response?.result.invoice);
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const toggleModalOrderConfirm = () => {
        setIsModalOrderConfirm(!isModalOrderConfirm);
    };

    const toggleModalSuccessTransaction = () => {
        setIsModalSuccessTransaction(!isModalSuccessTransaction);
    };
    return (
        <div className="flex flex-col gap-3 flex-1">
            <div className="flex flex-row  rounded-lg gap-2 shadow-inner overflow-clip bg-cardLight dark:bg-cardDark relative">
                <div className="flex flex-col flex-1 gap-2 p-3 ">
                    <span className={` sm:text-md text-sm opacity-50 text-end`}>
                        Membership:  <span className="font-bold text-[#22BDE2]">{profileData?.level.toUpperCase()}</span>
                    </span>
                    <div className="flex flex-row justify-between items-center">
                        <div className="flex flex-row gap-2 items-center ">
                            <LazyLoadImage
                                src={profileData?.profil}
                                alt={profileData?.nama}
                                className=" object-cover sm:max-h-32 max-h-28 aspect-square rounded-full"
                                effect="blur"
                            />
                            <div className="flex flex-col flex-1 ">
                                <span
                                    className={` sm:text-xl text-base font-bold text-[#22BDE2]`}
                                >
                                    {profileData?.nama}
                                </span>
                                <span className={` sm:text-md text-sm opacity-50`}>
                                    {profileData?.email}
                                </span>
                            </div>
                        </div>
                        <div className="sm:flex hidden flex-col ">
                            {profileData?.level === "member" &&
                                <MemberStandarIcon className="w-20 h-20" />
                            }
                            {profileData?.level === "silver" &&
                                // <MemberSilverIcon className="w-20 h-20" />
                                <img
                                    src={require('../../assets/membership/SIVLER.png')}
                                    alt={profileData?.nama}
                                    className="object-contain  w-20 h-24"
                                    effect="blur"
                                />
                            }
                            {profileData?.level === "gold" &&
                                // <MembergoldIcon className="w-20 h-20" />
                                <img
                                    src={require('../../assets/membership/GOLD.png')}
                                    alt={profileData?.nama}
                                    className="object-contain  w-20 h-24"
                                    effect="blur"
                                />
                            }
                            {profileData?.level === "pro" &&
                                // <MemberProIcon className="w-20 h-20" />
                                <img
                                    src={require('../../assets/membership/PRO.png')}
                                    alt={profileData?.nama}
                                    className="object-contain  w-20 h-24"
                                    effect="blur"
                                />
                            }
                        </div>
                    </div>
                </div>
                <div className="flex flex-col sm:basis-3/12 basis-1/12 bg-gradient-to-t from-[#FFB6FF] to-[#B9BDFF] " > </div>
            </div>
            <div className="flex flex-col rounded-lg p-3 gap-2 shadow-inner bg-cardLight dark:bg-cardDark relative">
                <div className="flex flex-col gap-1 ">
                    <span className=" text-lg font-medium line-clamp-1 text-[#22BDE2]">
                        Upgrade Membershipmu!
                    </span>
                    <span className=" text-sm opacity-60 ">
                        Dapatkan berbagai keuntungan dengan upgrade status membershipmu, beli item dan topup makin untung!                    </span>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-2 p-3 bg-[#22BDE216]">
                    {[
                        {
                            icon: require('../../assets/images/membership/1.png'),
                            title: "Dapat Harga Spesial",
                            description: "Dapatkan harga yang lebih murah untuk setiap pembelian item."
                        },
                        {
                            icon: require('../../assets/images/membership/2.png'),
                            title: "Kupon Potongan Harga",
                            description: "Dapat kode promo dan kupon lebih banyak dengan premium."
                        },
                        {
                            icon: require('../../assets/images/membership/3.png'),
                            title: "Lebih Sering dapat Promo",
                            description: "Kamu gak akan kehabisan promo setiap harinya."
                        }
                    ].map((info, index) => (
                        <div key={index} className={`flex flex-row gap-1 items-center p-2 sm:justify-center ${index === 2 ? 'col-span-2 lg:col-span-1 ' : 'col-span-2 sm:col-span-1'} `}>
                            <img
                                alt={info.title}
                                src={info.icon} className="w-20 h-20 object-contain" />
                            <div className="flex flex-col ">
                                <span className="text-[#22BDE2] text-base font-medium">
                                    {info.title}
                                </span>
                                <p className=" text-xs opacity-60 ">
                                    {info.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex flex-col rounded-lg shadow-inner bg-cardLight dark:bg-cardDark relative">
                <div className="flex flex-col gap-1 p-3">
                    <span className=" text-lg font-medium line-clamp-1 text-[#22BDE2]">
                    Pilihan Upgrade
                    </span>
                </div>
                <div className="grid sm:grid-cols-3 grid-cols-1  gap-2 px-3 pb-3 min-h-[70px]">
                    <ConditionalRender
                        productsData={listMemberData}
                        isLoading={listMemberLoading}
                        model={"emptyData"}
                    >
                        {listMemberData.map((item, index) => (
                            <button key={index}
                                onClick={() => {
                                    setMembership({ nama: item.nama, harga: item.harga });
                                    setSelectedPaymentItems([])
                                }}
                                className={`flex flex-row gap-2 flex-1 ${membership.nama === item.nama ? 'bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] ' : 'bg-lightColor dark:bg-darkColor'} shadow-inner rounded-md items-center overflow-clip  `}>
                                <LazyLoadImage
                                    src={item?.gambar}
                                    alt={item.layanan}
                                    className=" object-contain flex p-2  xl:h-40 h-24 aspect-square "
                                    effect="blur"
                                />
                                <div className="flex flex-col flex-1  p-2  items-start">
                                    <span className={` ${membership.nama === item.nama ? 'text-[#ffffff]' : 'text-[#22BDE2]'} sm:text-lg text-base font-medium line-clamp-1`}>
                                        {item.nama}
                                    </span>
                                    <span className="opacity-60 text-sm font-base line-clamp-1">
                                        {formatRupiah(item.harga)}
                                    </span>
                                </div>
                                <div className={`${membership.nama === item.nama ? 'hidden' : 'flex'} flex-col h-full basis-1/12 bg-gradient-to-t from-[#FFB6FF] to-[#B9BDFF]`} > </div>
                            </button>
                        ))}
                    </ConditionalRender>
                </div>
            </div>

            <div id="payment">
                <div className="flex flex-col rounded-lg min-h-[200px] gap-2 pb-3 shadow-inner bg-cardLight dark:bg-cardDark">

                    <div className="p-3 pb-2 text-[#22BDE2]">
                        <span className=" text-base font-semibold">Pilih Metode Pembayaran</span>
                    </div>
                    <PaymentMethodComponent
                        paymentData={paymentData}
                        paymentLoading={paymentLoading}
                        selectedNominalItems={membership}
                        selectedPaymentItems={selectedPaymentItems}
                        selectedrekPayment={selectedrekPayment}
                        setSelectedPaymentItems={setSelectedPaymentItems}
                        setselectedrekPayment={setselectedrekPayment}
                        hargaFix={setHargaFix}
                    />
                    {selectedPaymentItems.length === 0 ? null :
                        <div className="flex-1 sm:flex-row gap-2 flex-col flex justify-between m-3 mb-0 rounded-lg">
                            <div className="flex flex-col justify-end gap-2 flex-1">
                                {hargaFix.logo &&
                                    <img
                                        alt="pembayaran"
                                        className="h-7 object-contain w-16 "
                                        src={hargaFix.logo} />
                                }
                                <span className=" text-xl font-bold line-clamp-1 ">
                                    {formatRupiah(hargaFix.harga)}
                                </span>
                            </div>
                            <div className="flex flex-col gap-2">
                                <Button
                                    initialValue="Upgrade Membership"
                                    type="fill"
                                    color={'#ffffff'}
                                    iconLeft={<MoneyIcon />}
                                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor"
                                    onClick={() => {
                                        const phoneRegex = /^\+62\d{8,17}$/;
                                        if (selectedPaymentItems.pake_rek === "1") {
                                            if (selectedrekPayment[0].nama === "Saldo") {
                                                if (selectedrekPayment[0].value.length < 6) {
                                                    toast.error(`PIN pada Pembayaran ${selectedrekPayment[0].nama} tidak valid. Mohon periksa masukan Anda.`, {
                                                        position: toast.POSITION.TOP_RIGHT,
                                                    });
                                                } else {
                                                    getOrderConfirm();
                                                }
                                            } else {
                                                if (!phoneRegex.test(selectedrekPayment[0].value)) {
                                                    toast.error(`Nomor WhatsApp pada Pembayaran ${selectedrekPayment[0].nama} tidak valid. Mohon periksa masukan Anda.`, {
                                                        position: toast.POSITION.TOP_RIGHT,
                                                    });
                                                } else {
                                                    getOrderConfirm();
                                                }
                                            }
                                        } else {
                                            getOrderConfirm();
                                        }
                                    }}
                                />
                                <div className="flex flex-row gap-2 items-center">
                                    <DefenderIcon />
                                    <span className=" text-xs flex-1">Pembayaran anda terjamin aman </span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <ModalOrderConfirm
                active={isModalOrderConfirm}
                onClose={toggleModalOrderConfirm}
                // productData={inputSaldo}
                orderConfirm={orderConfirm}
                setOrderFix={setOrderFix}
                type={'membership'}
            />
            <ModalBox active={isModalSuccessTransaction} onClose={toggleModalSuccessTransaction}>
                <div className="flex flex-col gap-3">
                    <div className="flex items-center justify-center">
                        <img className="flex w-[50%]"
                            src={require("../../assets/images/successTransaction.gif")}
                            alt="promo not found"
                        />
                    </div>
                    <div className="flex flex-col">
                        <span
                            className={` text-lg font-semibold `}
                        >
                            Transaksi Berhasil!
                        </span>
                        <span
                            className={` text-sm `}
                        >
                            Periksa halaman transaksi anda untuk info lebih lanjut
                        </span>
                    </div>
                    <div className="flex flex-row gap-2">

                        <Button
                            initialValue="Lihat Invoice"
                            type="fill"
                            className="bg-[#22BDE2] text-darkColor w-full"
                            onClick={() => {
                                toggleModalSuccessTransaction();
                                handleClickLoading('/invoice/' + invoice)
                            }}
                        />
                    </div>
                </div>
            </ModalBox>

        </div>
    );
}

export default MembershipPages;
